"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DumbappSubmission = void 0;
class DumbappSubmission {
  constructor(dumbapp, data) {
    this.dumbapp = dumbapp;
    this.data = data;
  }
  get id() {
    var _this$data;
    return (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.id;
  }
  get type() {
    var _this$data2;
    return (_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : _this$data2.executor;
  }
}
exports.DumbappSubmission = DumbappSubmission;
//# sourceMappingURL=DumbappSubmission.js.map